// The tabs of one browser share amplify's session (its tokens are in
// localStorage, see authStorage.js), but a tab learns who is signed in only when
// it loads. Without this, a tab still showing Login, or one account, would act on
// a session another tab has since started, ended or switched: finishing a reset
// from the email's link signs in, in a new tab, while the tab that asked for the
// reset still shows Login.
//
// watchAccountElsewhere calls back when another tab changes which account is
// signed in. It watches amplify's LastAuthUser key, which changes only when an
// account signs in, signs out, or signs in over another: a token refresh writes
// the same value again, and a storage event fires only for a change. A storage
// event reaches the origin's other tabs, never the tab that made the change, and
// a key of null means the whole of localStorage was cleared.
const LAST_AUTH_USER = /^CognitoIdentityServiceProvider\.[^.]+\.LastAuthUser$/;

export function watchAccountElsewhere(onChange, target = window) {
  const handleStorage = (event) => {
    if (event.storageArea !== target.localStorage) {
      return;
    }
    if (
      event.key === null ||
      (LAST_AUTH_USER.test(event.key) && event.oldValue !== event.newValue)
    ) {
      onChange();
    }
  };
  target.addEventListener('storage', handleStorage);
  return () => target.removeEventListener('storage', handleStorage);
}
